import { getInitialState } from './initialState';

const initialState = getInitialState(false);

const paymentLinkReducer = (state = initialState) => {
  return state;
};

export default paymentLinkReducer;
